export default __webpack_public_path__ + "static/media/slider-photo-example.6947b387.jpg";